import * as React from 'react'
import './CustomMetrics.css'
import CustomMetricRowContainer from './CustomMetricRow/CustomMetricRowContainer'
import Spinner from '@mulesoft/anypoint-components/lib/Spinner'
import { CustomMetric } from './model'
import { DashboardLoadingState } from '@mulesoft/monitoring-center-components/lib/components/Dashboard/DashboardLoadingState'
import { Dashboard, DashboardError } from '@mulesoft/monitoring-center-components'
import { CustomMetricsLanding } from './CustomMetricsLanding/CustomMetricsLanding'
import { buildCompleteCustomMetricsDashboard, buildHiddenCustomMetricDashboard } from './CustomMetricRow/util/GraphService'
import { Environment, Profile } from '../../../remote-api/CoreServicesRemoteApi'

export type ExternalEventProps = {
  onDashboardStateChange: (loading: DashboardLoadingState, uri: string, iframe?: HTMLIFrameElement) => void
  onDashboardError: (error: DashboardError) => void
}

export type ValueProps = ExternalEventProps & {
  from: string
  to: string
  orgId: string
  envId?: string
  appId?: string
  rsType?: string
  targetId?: string
  metrics?: CustomMetric[]
  isLoadingMetrics?: boolean
  dashboardType: string
  customMetricsKey?: string
  profile?: Profile
  selectedEnvironment?: Environment
}

export type EventProps = {
  fetchCustomMetrics: () => void
}

export type Props = ValueProps & EventProps

export default class CustomMetrics extends React.Component<Props> {

  constructor(props: Props) {
    super(props)
  }

  // Render methods

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, prevContext: any): void {
    if (
      (prevProps.from && this.props.from !== prevProps.from) ||
      (prevProps.to && this.props.to !== prevProps.to) ||
      (!prevProps.from && this.props.from) ||
      (!prevProps.to && this.props.to) ||
      (this.props.dashboardType === 'custom-metrics' && prevProps.dashboardType !== 'custom-metrics')
    ) {
      this.props.fetchCustomMetrics()
    }
  }

  componentWillMount(): void {
    if (this.props.from || this.props.to) {
      this.props.fetchCustomMetrics()
    }
  }

  render() {
    const {
      isLoadingMetrics,
      metrics,
      orgId,
      envId,
      appId,
      rsType,
      targetId,
      from,
      to,
      customMetricsKey,
      profile,
      selectedEnvironment
    } = this.props
    
    const isProductionEnv = selectedEnvironment && selectedEnvironment.isProduction
    const hiddenDashboard = (metrics && metrics.length > 0) ?
      buildCompleteCustomMetricsDashboard(metrics, orgId, envId, appId, rsType, targetId, isProductionEnv) :
      buildHiddenCustomMetricDashboard(orgId, envId, appId, rsType, targetId)

    return (
      <div className={(metrics && metrics.length === 1) ? 'custom-metrics custom-metrics-one' : 'custom-metrics'}>
        <div className={'custom-metrics-hidden'}>
          <Dashboard
            key={`${from}-${to}-${customMetricsKey || ''}`}
            dashboardData={hiddenDashboard}
            id={'anypoint-platform-dashboard-id'}
            sameOrigin={true}
            onDashboardStateChange={this.props.onDashboardStateChange}
            onDashboardError={this.props.onDashboardError}
            from={from}
            to={to}
            profile={profile}
          />
        </div>
        {
          isLoadingMetrics &&
          <div className="custom-metrics-loading">
              <Spinner/>
          </div>
        }
        {!isLoadingMetrics && metrics && metrics.length === 0 && <CustomMetricsLanding/>}
        {!isLoadingMetrics && metrics && metrics.map((metric, index) =>
          <CustomMetricRowContainer
            key={`${metric}-${index}`}
            orgId={this.props.orgId}
            envId={this.props.envId}
            appId={this.props.appId}
            rsType={this.props.rsType}
            targetId={this.props.targetId}
            from={this.props.from}
            to={this.props.to}
            metric={metric}
            onDashboardStateChange={this.props.onDashboardStateChange}
            onDashboardError={this.props.onDashboardError}
          />
        )}
      </div>
    )
  }
}
